<app-uni-page [parent]="this" *ngIf="isPageReady" pageTitle="{{ title }}" [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <div  style="height: 85px">
    <div uni-flex-row class="ml-12">
      <uni-field style="width: 350px" label="Chart">
        <p-dropdown [(ngModel)]="chart" [options]="charts"  optionLabel="name" />
      </uni-field>
      <uni-field *ngIf="chart.usesAccount" >
        <button pButton type="button" class="p-button-raised" (click)="selectAccount()">
          <span>Select Account</span>
        </button>
      </uni-field>
      <uni-field *ngIf="chart.usesAccount" label="Account">
        <input [ngModel]="account?.accountName" pInputText disabled/>
      </uni-field>
      <uni-field>
        <button *ngIf="chart.usesAccount" pButton type="button" class="p-button-raised" (click)="clearAccount()">
          <span>Clear Account</span>
        </button>
      </uni-field>
    </div>
  </div>
  <div style="height: calc(100% - 85px);" class="content-card">
    <!-- <app-chart-invoice-delay style="height: calc(100% - 75px);" [account]="account"></app-chart-invoice-delay> -->
    <app-chart-invoice-delay  *ngIf="chart.id=='InvoiceDelay'" style="height: calc(100% - 85px);" [account]="account"></app-chart-invoice-delay>
    <app-chart-invoice-stats  *ngIf="chart.id=='InvoiceStats'" style="height: calc(100% - 85px);" [account]="account"></app-chart-invoice-stats>
    <app-chart-manuf-inventory  *ngIf="chart.id=='ManufInventoryCount'" style="height: calc(100% - 85px);" ></app-chart-manuf-inventory>
    <app-chart-jo-stats  *ngIf="chart.id=='JoStats'" style="height: calc(100% - 85px);" ></app-chart-jo-stats>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
  </div>
  <div>
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>